
import React from "react";
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import type { MortgageData } from "../../CalculatorTabs";
import { calculateMortgageData } from "@/utils/calculator/mortgageCalculator";
import { AutoCalculateOptions } from "../../utils/types";
import { MetricTooltip } from "../../advanced/analytics/MetricTooltip";

interface CreditScoreSliderProps {
  mortgageData: MortgageData;
  setMortgageData: React.Dispatch<React.SetStateAction<MortgageData>>;
  autoCalculate: AutoCalculateOptions;
}

const CreditScoreSlider: React.FC<CreditScoreSliderProps> = ({ 
  mortgageData, 
  setMortgageData, 
  autoCalculate 
}) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label className="text-sm font-medium">Credit Score <MetricTooltip metric="creditScore" /></Label>
        <span className="text-sm font-medium">{mortgageData.creditScore}</span>
      </div>
      <Slider
        defaultValue={[mortgageData.creditScore]}
        min={500}
        max={850}
        step={10}
        value={[mortgageData.creditScore]}
        onValueChange={(value) => {
          const newValue = Array.isArray(value) ? value[0] : value;
          setMortgageData(prev => calculateMortgageData({
            ...prev,
            creditScore: newValue
          }));
        }}
        className="my-4"
      />
      <div className="flex justify-between text-xs text-homebuyer-gray">
        <span>Poor (500)</span>
        <span>Excellent (850)</span>
      </div>
    </div>
  );
};

export default CreditScoreSlider;
